// R2-01L A4-02 · read-only line quantity breakdown + protection badge (G2/G3/G7/G10).
import { LEGACY_SPLIT_LABEL, PROTECTION_TEXT, legacySplitUnavailable } from "@/lib/qtyDisplay";

const n = (v) => (v === null || v === undefined ? "—" : Number(v).toLocaleString("en-IN", { maximumFractionDigits: 3 }));

export function ProtectionBadge({ cls, testid }) {
  if (!cls) return null;
  return (
    <span data-testid={testid} title={PROTECTION_TEXT[cls] || cls}
      className="inline-flex ml-1 px-1 py-0.5 rounded-sm border border-amber-500/50 text-amber-300 bg-amber-500/10 text-[8px] font-mono uppercase tracking-widest">
      {cls.replace("_", " ")}
    </span>
  );
}

export function LineQtyBreakdown({ line, cancelled, testid }) {
  if (!line) return <span className="text-[9px] text-zinc-600">—</span>;
  const p = line.position;
  const legacy = legacySplitUnavailable(p);
  const pending = cancelled ? 0 : p.pending;
  return (
    <div className="text-[9px] font-mono leading-tight text-zinc-400 whitespace-nowrap" data-testid={testid}>
      <div>Orig <span data-testid={`${testid}-orig`} className="text-zinc-200">{p.O === null || p.O === undefined ? "Not established" : n(p.O)}</span>
        {" · "}Add <span data-testid={`${testid}-add`} className="text-zinc-200">{n(p.A)}</span></div>
      {legacy ? (
        <div className="text-amber-300" data-testid={`${testid}-legacy`}>{LEGACY_SPLIT_LABEL}: {n(p.cancelled_qty)}</div>
      ) : (
        <div>Cancel <span data-testid={`${testid}-cancel`} className="text-zinc-200">{n(p.C)}</span>
          {" · "}Close <span data-testid={`${testid}-close`} className="text-zinc-200">{n(p.K)}</span></div>
      )}
      <div>Deliv <span data-testid={`${testid}-delivered`} className="text-zinc-200">{n(p.D)}</span>
        {" · "}Pend <span data-testid={`${testid}-pending`} className={pending > 0 ? "text-amber-300" : "text-emerald-400"}>{n(pending)}</span></div>
      {p.short_closed && p.P > 0 && (
        <div className="text-sky-300" data-testid={`${testid}-packed-awaiting`}>Packed – awaiting dispatch: {n(p.P)} m</div>
      )}
    </div>
  );
}

export default LineQtyBreakdown;
